import React from 'react';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedUserTypes?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  // For now, just render children without any checks
  return <>{children}</>;
};

export default ProtectedRoute; 